var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGestao(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "#F3F4F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 38C47.375 38 48 38.625 48 39.25V41.75C48 42.4531 47.375 43 46.75 43H10.5C9.09375 43 8 41.9062 8 40.5V14.25C8 13.625 8.54688 13 9.25 13H11.75C12.375 13 13 13.625 13 14.25V38H46.75ZM44.25 15.5C44.875 15.5 45.5 16.125 45.4219 16.75V26.0469C45.4219 27.6875 43.4688 28.5469 42.2969 27.375L39.7188 24.7969L32.2188 32.2969C31.2812 33.3125 29.6406 33.3125 28.7031 32.2969L23 26.5938L19.3281 30.1875C18.8594 30.6562 18.0781 30.6562 17.6094 30.1875L15.8125 28.3906C15.3438 27.9219 15.3438 27.1406 15.8125 26.6719L21.2031 21.2812C22.1406 20.2656 23.7812 20.2656 24.7188 21.2812L30.5 26.9844L36.2031 21.2812L33.625 18.7031C32.4531 17.5312 33.3125 15.5 34.9531 15.5H44.25Z",
    fill: "#F4731D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestao);
export default __webpack_public_path__ + "static/media/gestao.b273ade6e9d7a2878b1a9f23ea6d3d26.svg";
export { ForwardRef as ReactComponent };